import React, { useEffect, useState } from "react";
import { AllAvailability, Modaal } from "..";
import { useDispatch, useSelector } from "react-redux";
import { actionPatient } from "../../redux/actions";
import { useTranslation } from "react-i18next";

const ViewAllAvailability = ({
    show,
    onHide,
    credentials1,
    selectedOptions2,
    loginData,
    handleDateChange,
}) => {
    const { t } = useTranslation();
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    const [credentials, setCredentials] = useState({
        appDate: formattedDate,
        location: "",
        physicianService: [],
        isMale: 0,
        languageId: [],
        appointmentType: 2,
        clinicGuid: null,
        IsClinicSchedule: false,
        userTimeZone: loginData?.timeZoneId,
    });
    const dispatch = useDispatch();
    const [availableSlot, setAvailableSlot] = useState();
    console.log("availableSlot", availableSlot);

    useEffect(() => {
        if (credentials1 && selectedOptions2?.value) {
            dispatch(
                actionPatient.postAllAvailability(credentials1, selectedOptions2.value)
            );
        }
    }, [credentials1, selectedOptions2, dispatch]);

    const postAllAvailabilityData = useSelector(
        (state) => state.patient.postAllAvailabilityData?.data
    );

    useEffect(() => {
        if (postAllAvailabilityData) {
            setAvailableSlot(postAllAvailabilityData?.result?.availableSlots);
        }
    }, [postAllAvailabilityData]);
    const shiftDateByWeeks = (baseDateStr, weekDiff) => {
        const baseDate = new Date(baseDateStr);
        baseDate.setDate(baseDate.getDate() + weekDiff * 7);

        const y = baseDate.getFullYear();
        const m = String(baseDate.getMonth() + 1).padStart(2, "0");
        const d = String(baseDate.getDate()).padStart(2, "0");

        return `${y}-${m}-${d}`;
    };
    const handlePreviousAvailability = () => {
        const currentDate = credentials.appDate;
        const prevDate = shiftDateByWeeks(currentDate, -1);

        const today = new Date();
        const prev = new Date(prevDate);

        // Prevent going before today
        if (prev < today.setHours(0, 0, 0, 0)) {
            return; // Do nothing
        }

        const updatedCredentials = {
            ...credentials,
            appDate: prevDate,
        };

        setCredentials(updatedCredentials);

        dispatch(
            actionPatient.postFetchNextAppointments(
                updatedCredentials,
                selectedOptions2.value,
                true
            )
        );
    };
    const handleNextAvailability = () => {
        const currentDate = credentials.appDate;
        const nextDate = shiftDateByWeeks(currentDate, 1);

        const updatedCredentials = {
            ...credentials,
            appDate: nextDate,
        };

        setCredentials(updatedCredentials);

        dispatch(
            actionPatient.postFetchNextAppointments(
                updatedCredentials,
                selectedOptions2.value,
                true
            )
        );
    };
    const getFetchNextAppointnentsData = useSelector(
        (state) => state.patient.getFetchNextAppointnentsData?.data
    );

    console.log("getFetchNextAppointnentsData", getFetchNextAppointnentsData);


    useEffect(() => {
        if (getFetchNextAppointnentsData) {
            setAvailableSlot(getFetchNextAppointnentsData?.result?.availableSlots);
        }
    }, [getFetchNextAppointnentsData]);

    return (
        <Modaal.Modaal
            show={show}
            onHide={onHide}
            centered={true}
            scrollable={true}
            title={
                <h2 className="exado-title-nine text-capitalize">
                    {t("all_avaiability")}
                </h2>
            }
            bodyContent={
                <AllAvailability.AvailabilitySlotList
                    availableSlot={availableSlot}
                    onPerClick={handlePreviousAvailability}
                    onTimeClick={(time) => {
                        handleDateChange(time, true);
                        onHide();
                    }}
                    onNextClick={handleNextAvailability}
                />
            }
            size="md"
            className="input-modal view-all-availability"
        />
    );
};

export default ViewAllAvailability;
